export const DOWNLOAD_CONFIGURATION = 'DOWNLOAD_CONFIGURATION'
export const DOWNLOAD_CONFIGURATION_SUCCESS = 'DOWNLOAD_CONFIGURATION_SUCCESS'
export const DOWNLOAD_CONFIGURATION_FAILED = 'DOWNLOAD_CONFIGURATION_FAILED'
export const UPLOAD_CONFIGURATION = 'UPLOAD_CONFIGURATION'
export const UPLOAD_CONFIGURATION_SUCCESS = 'UPLOAD_CONFIGURATION_SUCCESS'
export const UPLOAD_CONFIGURATION_FAILED = 'UPLOAD_CONFIGURATION_FAILED'
export const EXPORT_CUSTOMERS = 'EXPORT_CUSTOMERS'
export const EXPORT_CUSTOMERS_SUCCESS = 'EXPORT_CUSTOMERS_SUCCESS'
export const EXPORT_CUSTOMERS_FAILED = 'EXPORT_CUSTOMERS_FAILED'
export const GET_CUSTOMER_EXTRACT_STATUS = 'GET_CUSTOMER_EXTRACT_STATUS'
export const GET_CUSTOMER_EXTRACT_STATUS_SUCCESS = 'GET_CUSTOMER_EXTRACT_STATUS_SUCCESS'
export const GET_CUSTOMER_EXTRACT_STATUS_FAILED = 'GET_CUSTOMER_EXTRACT_STATUS_FAILED'
